const darkTheme = {
  textColor: "#000000",
  bgColor: "#FFFFFF",
  actionColor: "#15E0FB"
};
const presets = {
  darkTheme
};
var presets_default = presets;
export {
  presets_default as default
};
//# sourceMappingURL=presets.js.map
